import React from "react";
import { twMerge } from "tailwind-merge";
import { linkTargetProps } from "../utils/links";
import { BoxIcon } from "lucide-react";
type ButtonVariant = 'primary' | 'ink' | 'white' | 'outlineDark' | 'outlineLight' | 'outlineRed';
interface ButtonLinkProps {
  href: string;
  children: React.ReactNode;
  variant?: ButtonVariant;
  leadingIcon?: BoxIcon;
  trailingIcon?: BoxIcon;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}
const variantClasses: Record<ButtonVariant, string> = {
  primary: 'bg-brand text-white hover:bg-brand-deep',
  ink: 'bg-ink text-paper hover:bg-ink-soft',
  white: 'bg-white text-ink hover:bg-paper',
  outlineDark: 'border border-paper/35 text-paper hover:border-paper hover:bg-paper/5',
  outlineLight: 'border border-ink/25 text-ink hover:border-ink hover:bg-ink/[0.03]',
  outlineRed: 'border border-white/70 text-white hover:border-white hover:bg-white/10'
};
export function ButtonLink({
  href,
  children,
  variant = 'primary',
  leadingIcon: Leading,
  trailingIcon: Trailing,
  className,
  onClick
}: ButtonLinkProps) {
  return <a href={href} onClick={onClick} {...linkTargetProps(href)} className={twMerge('group inline-flex h-12 min-h-[44px] items-center justify-center gap-2.5 whitespace-nowrap px-6 font-display text-[18px] font-semibold uppercase tracking-[0.06em] transition-colors duration-150 ease-out md:h-14 md:px-7', variantClasses[variant], className)} data-id="element-19" data-mp="ehvo0ly5u3t9">
      {Leading && <Leading aria-hidden="true" className="h-[18px] w-[18px] shrink-0" strokeWidth={2} data-id="element-20" data-mp="3mvkojkhbipto" />}
      <span data-id="element-21" data-mp="3rq8hpwn9o8el">{children}</span>
      {Trailing && <Trailing aria-hidden="true" className="h-[18px] w-[18px] shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" strokeWidth={2} data-id="element-22" data-mp="3dx8zvo00i23v" />}
    </a>;
}